import React, { useEffect, useReducer, createContext} from 'react';
import { format } from 'date-fns';
import { fetchMetaData } from '../actions/actionSelectors';
import { FETCH_INTAKEBOOK_DATE_CONFIG, SET_INTAKEBOOK_SELECTED_DATE, DISPLAY_ERROR_MESSAGE, INTAKEBOOK_SELECTED_DATE_CHANGED,
        RESET_MODEL_AND_ERROR_FLAGS, SET_SHOW_INSTRUCTION_MODEL, INTAKEBOOK_DATE_CHANGE_FLAG, SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE,
        FETCH_DATA_REQUEST, SET_CHANGE_REQUEST_NUMBER } from '../actions/actionTypes';
import { calendarIntakeBookReducer } from '../actions/calendar-intakebook-reducer';

const initialState = {
    intakeBookStartDate: null,
    minDate: null,
    maxDate: null,
    sessionTimeoutLimit: null,
    idleTimeoutLimit: null,
    isDateChangeFlag : false,
    isDateChanged : true,
    newSelectedDate : null,
    oldSelectedDate : null,
    unblockFromDate: null,
    selectedContractCodeValue: null,
    isLoading: false,
    isError: false,
    errorMessage: undefined,
    showModel: false,
    modelHeaderTitle: "",
    showInstructions: false,   
    isFileUploadedSuccessfully : false,
    isSuccessfullySaved: false,
    changeReqNumber: null,
    requestStatus: 0
}

export const CalendarIntakeBookContext = createContext();

export function CalendarIntakeBookProvider(props) {

    const [state, dispatch] = useReducer(calendarIntakeBookReducer, initialState);
    const { intakeBookStartDate, minDate, maxDate, sessionTimeoutLimit, idleTimeoutLimit, isDateChanged
            , isLoading, showModel, errorMessage, isError, modelHeaderTitle, showInstructions, isDateChangeFlag
            , newSelectedDate, oldSelectedDate, isFileUploadedSuccessfully,selectedContractCodeValue,unblockFromDate, isSuccessfullySaved, changeReqNumber, requestStatus } = state;

    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));

        async function fetchMetaDataAsync() {
            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_INTAKEBOOK_DATE_CONFIG,
                        payload: {
                            intakeBookStartDate: data.StartDate,
                            minDate: data.MinDate,
                            maxDate: data.MaxDate,
                            sessionTimeoutLimit: +(data.sessionTimeoutLimit),
                            idleTimeoutLimit: +(data.idleTimeoutLimit)
                        }
                    });
                })
                .catch((error) => {
                    setErrorOrWarningHandler(true,  "wentwrong", false, true, "calendar_intakebook", false, false);
                })
        }
        fetchMetaDataAsync();
    }, []);

    const ShowOrHideLoader = (loading) => {
        dispatch({ type: FETCH_DATA_REQUEST, payload: { isLoading: loading, isError: false, errorMessage: "" } });
    }

    const resetSubmittedAndErrorFlags = () => {
        dispatch({ type: RESET_MODEL_AND_ERROR_FLAGS });       
        if (isDateChangeFlag) {
            setMonthlyIntakeBookDate(oldSelectedDate);
            dispatch({ type: INTAKEBOOK_SELECTED_DATE_CHANGED , payload: { isDateChanged: isDateChanged ? false : true }  });
        }
        props.setLogoutFalse();
    }

    const setMonthlyIntakeBookDate = (selectedDate) => {
        if(selectedDate) {
            dispatch({ type: SET_INTAKEBOOK_SELECTED_DATE, payload: { intakeBookStartDate: selectedDate } }); 
        } 
    }

    const setErrorOrWarningHandler = (isModelError, errorModelMessage, isLoadingError, 
        showErrorModel, modelHeaderTitleError, isFileUploaded, isSaved, reqStatus) => {         
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,
                isLoading: isLoadingError,
                showModel: showErrorModel,
                isFileUploadedSuccessfully: isFileUploaded,
                modelHeaderTitle: modelHeaderTitleError,               
                isSuccessfullySaved : isSaved, 
                requestStatus : !reqStatus ? 0 : reqStatus
            }
        });
    }

    const handleConfirmationYesClick = () => {
        if(props.isLogout) {
            props.clearSessionData();
        }
        else if(isDateChangeFlag) {
            setMonthlyIntakeBookDate(newSelectedDate);
        } 
    }

    const selectedIntakeBookDateHandler = (selectedDate, oSelectedDate) => {
        dispatch({ type: INTAKEBOOK_DATE_CHANGE_FLAG, 
                    payload: { 
                                newSelectedDate: format(selectedDate, "dd/MM/yyyy") ,
                                oldSelectedDate: format(oSelectedDate, "dd/MM/yyyy")
                    }
        });        
    }

    const setShowInstructions = (showInstructionsModel) => {
        dispatch({
            type: SET_SHOW_INSTRUCTION_MODEL,
            payload: {
                showModel: showInstructionsModel,
                showInstructions: showInstructionsModel,
                modelHeaderTitle: showInstructionsModel ? "instruction" : ""
            }
        })
    }

    const setChangeRequestNumber = (crNumber) =>{
        dispatch({
            type: SET_CHANGE_REQUEST_NUMBER,
            payload: {
                changeReqNumber : crNumber
            }
        })
    }

    const setUnblockFromDateAndContractCode = (fDate, contractCode) =>{
        dispatch({
            type: SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE,
            payload: {
                unblockFromDate : fDate,
                selectedContractCodeValue: contractCode
            }
        })
    }

    const provider = {
        intakeBookStartDate,
        minDate,
        maxDate,
        sessionTimeoutLimit,
        idleTimeoutLimit,
        isDateChanged,
        isLoading,
        isError,
        errorMessage,
        showModel,
        modelHeaderTitle,
        showInstructions,
        isDateChangeFlag,
        newSelectedDate,
        oldSelectedDate,
        unblockFromDate,
        selectedContractCodeValue,
        resetSubmittedAndErrorFlags,
        selectedIntakeBookDateHandler: selectedIntakeBookDateHandler,
        setMonthlyIntakeBookDate,
        setShowInstructions,
        setErrorOrWarningHandler,
        handleConfirmationYesClick,
        ShowOrHideLoader,          
        isFileUploadedSuccessfully,
        isSuccessfullySaved, 
        changeReqNumber, 
        setChangeRequestNumber,
        requestStatus,
        setUnblockFromDateAndContractCode
    }

    return (
        <CalendarIntakeBookContext.Provider value={provider}>
            {props.children}
        </CalendarIntakeBookContext.Provider>
    );
}